export default __webpack_public_path__ + "static/media/Robot.92ee1005.png";